import { GridSkeleton } from "@/components/Skeletons";

export function AHESkeleton() {
  return (
    <div className="mx-auto flex w-1/2 gap-8">
      <GridSkeleton columns={2} rows={8} />
      <GridSkeleton columns={2} rows={8} />
    </div>
  );
}
